/*
 * Desktop - PDP - 10000 17500 Bnpl Options  --  variant: Affirm As Low As
 * Moonshot experiment id: 12442479   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-10-03
 * Audience: DESKTOP   Target: pdp_10000_17500   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_d_bnpl_10000_17500
 */
MGExp.run('pdp_d_bnpl_10000_17500', { name: "Desktop - PDP - 10000 17500 Bnpl Options / Affirm As Low As", platform: 'desktop', target: 'pdp_10000_17500' }, function () {
  !(function () {
    let t = [".pdp-payment-options > .m-auto", ".pdp-payment-options > span"],
      i = [];
    async function e(e, a, n, o, s) {
      let m = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: i,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(e, a, n, o, s, m);
    }
    (e(
      ["div.pdp-payment-options"],
      ".msai-multi-css-marker",
      (t, i) => {
        i[0].classList.add("msai-multi-css-marker");
      },
      ".pdp-payment-options.msai-multi-payment-options-updated{flex-direction:column;align-items:normal}.msai-payment-text{font-size:14px;line-height:1.4;color:#000000;margin-top:8px}.msai-payment-text a{text-decoration:underline;color:inherit}img.msai-inline{display:inline;margin:0 0 4px 0}.pdp-payment-options > .m-auto,.pdp-payment-options > span{display:none}",
    ),
      e(
        ["div.pdp-payment-options", ".affirm-ala-price"],
        ".msai-multi-payment-options-updated",
        function (t, i) {
          const [e, a] = i,
            n = e.querySelector("span#payment-options-btn");
          if (n) {
            const t = document.createElement("div");
            ((t.className = "msai-payment-text"),
              (t.innerHTML = `As low as ${a.innerText}/mo with <img class="m-auto msai-inline" src="https://cdn.shopify.com/s/files/1/0133/9195/3977/files/pay-affirm.png?v=1717438034" alt="affirm">. <a href='#' class="msai-affirm-trigger">Prequalify now</a>.`),
              n.parentNode.insertBefore(t, n));
          }
          let o = document.querySelector(".msai-affirm-trigger");
          if (o) {
            let t = document.querySelector(".affirm-modal-trigger");
            t &&
              (o.onclick = function () {
                t.click();
              });
          }
          e.classList.add("msai-multi-payment-options-updated");
        },
      ));
  })();
});
